import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue';
import { path } from 'd3';

const routes = [
  {
    path: '/',
    component: MainLayout,
    redirect: 'profile',
    meta: { requiresAuth: true },
    children:[
      {
        path: '/',
        name: 'home',
        component: () => import('../views/TaskView.vue'),
      },
      // {
      //   path: '/dashboard-analytics',
      //   name: 'dashboard',
      //   component: () => import('../views/Dashboard.vue'),
      // },
      {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/Profile.vue'),
      },
      // {
      //   path: '/taskboard',
      //   name: 'taskboard',
      //   component: () => import('../views/TaskBoard.vue'),
      // },
      // {
      //   path: '/kanban',
      //   name: 'kanban',
      //   component: () => import('../views/KanbanBoard.vue'),
      // },
      {
        path: '/quiz',
        name: 'quiz',
        component: () => import('../views/QuizView.vue'),
      },

    ]
  },

  {
    path: '/gantt-chart',
    name: 'gantt-chart',
    component: () => import('/src/GantChart.vue')
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Auth/LoginView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Auth/RegisterView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const token = localStorage.getItem('token')

  if (to.meta.requiresAuth && !token) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  if ((to.name === 'login' || to.name === 'register') && token) {
    return { name: 'home' }
  }
})


export default router